import { render, staticRenderFns } from "./login-layout-login.vue?vue&type=template&id=23bc35a7&scoped=true&"
import script from "./login-layout-login.ts?vue&type=script&lang=ts&"
export * from "./login-layout-login.ts?vue&type=script&lang=ts&"
import style0 from "./login-layout-login.scss?vue&type=style&index=0&id=23bc35a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc35a7",
  null
  
)

export default component.exports